import * as React from "react"
import { Box, Typography } from "@mui/material"
import { formatPrice } from "@ui-seeker/utils"


export default function ActualListBlock({ actualPrice, listPrice, currency, variant="body2" }) {
	return <Box display="flex" flexDirection="column" alignItems="flex-end">
		<Typography variant={variant} sx={{ mr: 2 }}>
			{ formatPrice(actualPrice, currency) }
		</Typography>
		{ !!listPrice && <Typography variant={variant} sx={{ color: "text.disabled", textDecoration: "line-through", fontSize: "0.75rem" }}>
			{ formatPrice(listPrice, currency) }
		</Typography> }
	</Box>
}